module.exports = __webpack_public_path__ + "assets/img/driver-btn-9db796d3.png";